import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import AuthGuard from "./guards/auth-guard";
import Transaction from "./views/Transaction";
import ConfirmDelete from "./views/ConfirmDelete.vue";
import Reports from "./views/Reports";
import Print from "./views/Print";
import TaxDay from "./views/Taxday";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/add-transaction",
      name: "add-transaction",
      component: Transaction,
      beforeEnter: AuthGuard
    },
    {
      path: "/edit-transaction/:id",
      name: "edit-transaction",
      component: Transaction,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/delete-transaction/:id",
      name: "delete-transaction",
      component: ConfirmDelete,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/transactions",
      name: "transactions",
      beforeEnter: AuthGuard,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Transactions.vue")
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      beforeEnter: AuthGuard
    },
    {
      path: "/print",
      name: "print",
      component: Print,
      beforeEnter: AuthGuard
    },
    {
      path: "/tax-day",
      name: "tax-day",
      component: TaxDay,
      beforeEnter: AuthGuard
    }
  ]
});
